import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { IconCheckbox } from '../../../../../../assets/icons/icon-checkbox';

type DashboardPartVisibilityProps = {
  visibleMode: boolean;
  isVisible: boolean;
  children: React.ReactNode;
  onToggle: () => void;
};

export const DashboardPartVisibility: React.FC<DashboardPartVisibilityProps> = ({
  visibleMode,
  isVisible,
  children,
  onToggle,
}) => {
  return !visibleMode ? (
    <>{isVisible ? children : null}</>
  ) : (
    <Box position="relative">
      <Box sx={{ opacity: isVisible ? 1 : 0.25, ...(!isVisible && { pointerEvents: 'none' }) }}>{children}</Box>
      <IconButton
        onClick={onToggle}
        sx={{
          position: 'absolute',
          top: -8,
          right: 8,
          width: 56,
          height: 56,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <IconCheckbox isChecked={isVisible} isDisabled={false} />
      </IconButton>
    </Box>
  );
};
